export default "/4b9039858ffbe849969b023cc7a7ab82.jpg";